import "react-toastify/dist/ReactToastify.css";

import React, {useEffect, useState} from "react";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import {uploadDocuments, uploadProfile} from "./helper";
import { query, where } from "firebase/firestore";
import AddDocuments from "./AddDocuments";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import FormControl from "@mui/material/FormControl";
import Loader from "./Loader";
import MenuItem from "@mui/material/MenuItem";
import RemoveIcon from "@mui/icons-material/Remove";
import Select from "@mui/material/Select";
import db from "../firebase";
import styled from "styled-components";
import {toast} from "react-toastify";

const FormData = {
  allowedLeaves: "",
  address: "",
  bankName: "",
  bankAccountNumber: "",
  blood: "",
  code: "",
  checkIn: "",
  checkOut: "",
  documentNumber: "",
  designation: "",
  department: "",
  dob: "",
  doj: "",
  documents: [],
  email: "",
  emergencyContact: "",
  education: "",
  empType: "",
  esicNumber: "",
  gender: "",
  name: "",
  phoneNumber: "",
  pfnumber: "",    // This stays as pfnumber
  panNumber: "",
  SiteLocation: "",
  salary: "",
  uanNumber: "",
  disableCheckInOut: false,
  weeklyWorkingDays: "",
  aadharNumber: "",     // ADD THIS LINE
  drivingLicence: "",   // ADD THIS LINE
  status: "Active",
  hasDrivingLicence: "no",
};

const bloodgrps = [
  "A+(A Positive)",
  "A-(A Negative)",
  "B+(B Positive)",
  "B-(B Negative)",
  "AB+(AB Positive)",
  "AB-(AB Negative)",
  "O+(O Positive)",
  "O-(O Negative)",
];

const employeeTypes = [
  "Office",
  "Site",
];

const AddUser = ({submitForm, show, editForm, handlEdit, formId}) => {
  const [userData, setUserData] = useState(FormData);
  const [imgShared, setImgShared] = useState("");
  const [imgLinkLoc, setLinkLoc] = useState({});
  const [siteLocation, setLocation] = useState([]);
  const [showField, setShowFields] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});


  const [documents, setDocuments] = useState([]);

  const userRef = collection(db, "LoginPhones");

  useEffect(() => {
    getLocations();
  }, []);

  const getLocations = async () => {
    try {
      const locationRef = collection(db, "SiteData");
      const docRef = await getDocs(locationRef);
      const docSnap = docRef.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setLocation(docSnap);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    if (show === "adduser") {
      submitForm();
    } else {
      handlEdit();
    }
  };

  const getData = async () => {
    try {
      const docSnap = await getDoc(doc(db, "LoginPhones", formId));
      const dataRef = docSnap.data();
      if (dataRef) {
        setUserData({
          code: dataRef.code,
          name: dataRef.name,
          SiteLocation: dataRef.SiteLocation,
          phoneNumber: dataRef.phoneNumber.slice(3),
          designation: dataRef.designation,
          department: dataRef.department,
          email: dataRef.email,
          address: dataRef.address,
          documentNumber: dataRef?.documentNumber,
          dob: dataRef.dob,
          gender: dataRef.gender,
          education: dataRef.education,
          blood: dataRef.blood,
          documents: dataRef.documents,
          emergencyContact: dataRef.emergencyContact,
          salary: dataRef.salary,
          allowedLeaves: dataRef.allowedLeaves,
          weeklyWorkingDays: dataRef?.weeklyWorkingDays,
          checkIn: dataRef.checkIn,
          checkOut: dataRef.checkOut,
          profileImg: dataRef.profileImg,
          bankAccountNumber: dataRef.bankAccountNumber,
          empType: dataRef.empType,
          bankName: dataRef.bankName,
          doj: dataRef.doj,
          panNumber: dataRef.panNumber,
          pfnumber: dataRef.pfnumber,
          uanNumber: dataRef.uanNumber,
          esicNumber: dataRef.esicNumber,
          // Robust logic: Check the flag first, fallback to time check if flag missing
          disableCheckInOut: dataRef.disableCheckInOut ?? (!dataRef.checkIn && !dataRef.checkOut),
          hasDrivingLicence: dataRef.drivingLicence ? "yes" : "no",
        });

        setDocuments(dataRef.documents ?? []);
        setImgShared(dataRef.profileImg ?? "");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
  getData();
}, [formId]);

useEffect(() => {
  if (!formId) {
    generateEmployeeCode().then((code) => {
      setUserData(prev => ({ ...prev, code }));
    });
  }
}, [formId]);

const handlerForm = (e) => {
  let { name, value } = e.target;

  // PHONE & EMERGENCY → only numbers
  if (name === "phoneNumber" || name === "emergencyContact") {
    // Check if the new character is a digit
    const lastChar = value.slice(-1);
    if (lastChar && !/^\d$/.test(lastChar)) {
      // If last character is not a digit, don't update
      return;
    }
    
    // Remove any existing non-digits (just to be safe)
    value = value.replace(/\D/g, "");
    
    // Limit to 10 digits
    if (value.length > 10) {
      return;
    }
  }

  // AADHAAR → only numbers max 12
  if (name === "aadharNumber") {
    const lastChar = value.slice(-1);
    if (lastChar && !/^\d$/.test(lastChar)) {
      return;
    }
    value = value.replace(/\D/g, "");
    if (value.length > 12) return;
  }

  // DRIVING LICENCE - allow alphanumeric
  if (name === "drivingLicence") {
    value = value.toUpperCase(); // Convert to uppercase for consistency
  }

  // SALARY → only numbers
  if (name === "salary") {
    const lastChar = value.slice(-1);
    if (lastChar && !/^\d$/.test(lastChar)) {
      return;
    }
    value = value.replace(/\D/g, "");
  }

  setUserData(prev => ({ ...prev, [name]: value }));

  setErrors(prev => ({ ...prev, [name]: "" }));

  if (formId) {
    setLinkLoc(prev => ({ ...prev, [name]: value }));
  }
};
  const handlerImg = (e) => {
    setImgShared(e.target.files[0]);
  };
  
const validateForm = () => {
    console.log("Validating form with data:", {
    code: userData.code,
    name: userData.name,
    phone: userData.phoneNumber,
    aadhar: userData.aadharNumber,
    drivingLicence: userData.drivingLicence,
    hasDrivingLicence: userData.hasDrivingLicence
  });
  const phoneRegex = /^[6-9]\d{9}$/;
  const aadhaarRegex = /^\d{12}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const nameRegex = /^[a-zA-Z\s]{2,50}$/; // Only letters and spaces, 2-50 chars
  const accountNumberRegex = /^\d{9,18}$/; // Bank account numbers are typically 9-18 digits
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/; // IFSC code pattern
  const drivingLicenceRegex = /^[A-Z]{2}[0-9]{2}[0-9{4,11}]+$/; // Basic DL pattern

  // Required field validations
  // if (!userData.code?.trim()) 
  //   return "Employee code is required";
  
  if (!userData.name?.trim()) 
    return "Employee name is required";

  if (!nameRegex.test(userData.name.trim())) 
    return "Name should contain only letters and spaces (2-50 characters)";

  if (!userData.phoneNumber || !phoneRegex.test(userData.phoneNumber))
    return "Enter valid 10 digit Indian phone number starting with 6-9";

  if (!userData.empType)
    return "Select employee type";

  if (!userData.SiteLocation)
    return "Select employee location";

  if (!userData.status)
    return "Select employee status";

  // Email validation (if provided)
  if (userData.email && !emailRegex.test(userData.email))
    return "Invalid email format (e.g., name@example.com)";

  // Aadhaar validation (if provided)
  if (userData.aadharNumber && !aadhaarRegex.test(userData.aadharNumber))
    return "Aadhaar must be exactly 12 digits";

  // PAN validation (if provided)
  if (userData.panNumber && !panRegex.test(userData.panNumber))
    return "Invalid PAN number format (e.g., ABCDE1234F)";

  // Salary validation (if provided)
  if (userData.salary && (Number(userData.salary) < 0 || Number(userData.salary) > 10000000))
    return "Salary must be between 0 and 1,00,00,000";

  // Check-in/Check-out validation
  if (!userData.disableCheckInOut) {
    if (!userData.checkIn)
      return "Check-In time is required when Check-In/Out is enabled";
    
    if (!userData.checkOut)
      return "Check-Out time is required when Check-In/Out is enabled";
    
    if (userData.checkIn && userData.checkOut) {
      if (userData.checkOut <= userData.checkIn)
        return "Check-Out must be after Check-In";
    }
  }

  // Date validations
  if (userData.dob) {
    const today = new Date();
    const dob = new Date(userData.dob);
    const age = today.getFullYear() - dob.getFullYear();
    
    if (dob > today)
      return "Date of birth cannot be in the future";
    
    if (age < 18)
      return "Employee must be at least 18 years old";
    
    if (age > 100)
      return "Please verify the date of birth";
  }

  if (userData.doj) {
    const today = new Date();
    const doj = new Date(userData.doj);
    
    if (doj > today)
      return "Date of joining cannot be in the future";
  }

  // Bank account validation (if provided)
  if (userData.bankAccountNumber && !accountNumberRegex.test(userData.bankAccountNumber))
    return "Bank account number should be 9-18 digits";

  // Driving licence validation (if applicable)
  if (userData.hasDrivingLicence === "yes") {
    if (!userData.drivingLicence?.trim())
      return "Driving licence number is required when you have a licence";
    
    if (userData.drivingLicence.length < 8 || userData.drivingLicence.length > 16)
      return "Driving licence number should be 8-16 characters";
  }

  // Emergency contact validation (if provided)
  if (userData.emergencyContact && !phoneRegex.test(userData.emergencyContact))
    return "Emergency contact should be a valid 10-digit phone number";

  // PF/UAN/ESIC validations (if provided)
  if (userData.pfnumber && userData.pfnumber.length < 12)
    return "PF number should be at least 12 characters";

  if (userData.uanNumber && !/^\d{12}$/.test(userData.uanNumber))
    return "UAN number should be exactly 12 digits";

  if (userData.esicNumber && userData.esicNumber.length < 10)
    return "ESIC number should be at least 10 characters";

  return null; // No validation errors
};

  const submitDb = async (e) => {
  e.preventDefault();

  if (submitting) return;

  const validationError = validateForm();
  if (validationError) {
    toast.error(validationError, { position: "top-center" });
    return;
  }
  else {

  }

  setSubmitting(true);
  setLoading(true);

  try {
    const phone = "+91" + userData.phoneNumber;

    // ===== EDIT EMPLOYEE =====
    if (formId) {
      const existingDoc = await getDoc(doc(db, "LoginPhones", formId));
      const oldPhone = existingDoc.data()?.phoneNumber;

      const alreadyUsed = await isUserExist(phone);
      if (alreadyUsed && phone !== oldPhone) {
        toast.warn("Another employee already uses this phone number");
        return;
      }

      const profileImageUrl =
        imgShared && typeof imgShared !== "string"
          ? await uploadProfile(imgShared)
          : imgShared;

      const documentsData = await uploadDocuments(documents);

      await updateDoc(doc(db, "LoginPhones", formId), {
        ...imgLinkLoc,
        phoneNumber: phone,
        profileImg: profileImageUrl,
        documents: documentsData,
        disableCheckInOut: userData.disableCheckInOut,
        checkIn: userData.disableCheckInOut ? "" : userData.checkIn,
        checkOut: userData.disableCheckInOut ? "" : userData.checkOut,
      });

      toast.success("Successfully Updated Employee");
      handlEdit();
    }

    // ===== CREATE EMPLOYEE =====
    else {
      const alreadyUsed = await isUserExist(phone);
      if (alreadyUsed) {
        toast.warn("Employee Already Exist");
        return;
      }

      const profileImageUrl =
        imgShared && typeof imgShared !== "string"
          ? await uploadProfile(imgShared)
          : imgShared;

      const documentsData = await uploadDocuments(documents);
      const autoCode = await generateEmployeeCode();

      await addDoc(userRef, {
        ...userData,
        code: autoCode,   // ← THIS LINE IS IMPORTANT
        phoneNumber: phone,
        profileImg: profileImageUrl,
        documents: documentsData,
        timestamp: serverTimestamp(),
      });

      toast.success("Successfully Created Employee");
      submitForm();
    }

    setImgShared(null);
    setUserData(FormData);
    setShowFields(false);
    setLinkLoc({});

  } catch (err) {
    console.log(err);
    toast.error("Something went wrong while saving employee");
  } finally {
    setSubmitting(false);
    setLoading(false);
  }
};

const generateEmployeeCode = async () => {
  try {
    const snapshot = await getDocs(collection(db, "LoginPhones"));

    let maxNumber = 0;

    snapshot.forEach((doc) => {
      const data = doc.data();
      if (data.code && data.code.startsWith("EMP")) {
        const number = parseInt(data.code.replace("EMP", ""));
        if (number > maxNumber) {
          maxNumber = number;
        }
      }
    });

    const nextNumber = maxNumber + 1;
    const paddedNumber = String(nextNumber).padStart(3, "0");

    return `EMP${paddedNumber}`;
  } catch (error) {
    console.log("Error generating employee code:", error);
    return `EMP${Date.now()}`;
  }
};

    

  const handlerAddFields = (e) => {
    e.preventDefault();
    setShowFields(!showField);
  };

const isUserExist = async (phoneNumber) => {
  try {
    const q = query(
      collection(db, "LoginPhones"),
      where("phoneNumber", "==", phoneNumber)
    );

    const snapshot = await getDocs(q);
    return !snapshot.empty;
  } catch (err) {
    console.log(err);
    return false;
  }
};
  return (
    <>
      {show === "adduser" || editForm === "adduser" ? (
        <>
          <Container>
            {loading && <Loader />}
            <Box>
              <Header>
                <div>
                  <h2>{formId ? "Edit" : "Create New"} Employee</h2>
                  {!formId ? <p>Create a Employee below</p> : null}
                </div>

                <Icon onClick={handleClose}>
                  <ClearIcon />
                </Icon>
              </Header>

              <Form>
                <form onSubmit={submitDb}>
                  <SelctPhoto>
                    <BgImg>
                      {imgShared ? (
                        <img
                          src={
                            typeof imgShared == "string" ?
                              imgShared :
                              URL.createObjectURL(imgShared)
                          }
                          alt="material"
                        />
                      ) : (
                        <img
                          src="/assets/cam1.svg"
                          alt="material"
                          style={{width: "50px", height: "50px"}}
                        />
                      )}
                    </BgImg>
                    <label htmlFor="images">Add User Photo</label>
                    <input
                      type="file"
                      accept="image/png, image/jpeg, image/jpg"
                      id="images"
                      onChange={handlerImg}
                      name="img"
                    />
                  </SelctPhoto>

                  <Inputs>
                    <div>
                      <label htmlFor="name">Employee Code</label>
                     <input
                      type="text"
                      id="code"
                      name="code"
                      value={userData.code}
                      readOnly
                    />
                    </div>
                  </Inputs>

                  <Inputs>
                    <div>
                      <label htmlFor="name">Employee Name*</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        placeholder="Enter name"
                        value={userData.name}
                        onChange={handlerForm}
                        required
                      />
                    </div>
                  </Inputs>

                  <Inputs>
                    <div>
                      <label htmlFor="SiteLocation">Employee Location</label>
                      <FormControl variant="standard" className="selectOtp">
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={userData.SiteLocation}
                          onChange={handlerForm}
                          label="SiteLocation"
                          name="SiteLocation"
                        >
                          <MenuItem value="" disabled={true}>
                            <em>Select Location</em>
                          </MenuItem>
                          {siteLocation &&
                            siteLocation.map((item, index) => {
                              return (
                                <MenuItem value={item.name} key={index}>
                                  {item.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <label htmlFor="phoneNumber">Phone Number</label>
                      <input
                        type="tel"
                        inputMode="numeric"
                        maxLength={10}
                        id="phoneNumber"
                        name="phoneNumber"
                        maxlength="10"
                        placeholder=""
                        value={userData.phoneNumber}
                        onChange={handlerForm}
                        required
                      />
                    </div>
                  </Inputs>
                  <Inputs>
                    <div>
                      <label htmlFor="empType">Employee Type</label>
                      <FormControl variant="standard" className="selectOtp">
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={userData.empType ? userData.empType : ""}
                          onChange={handlerForm}
                          label="empType"
                          name="empType"
                        >
                          <MenuItem value="" disabled={true}>
                            <em>Select Employee Type</em>
                          </MenuItem>
                          {employeeTypes.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </Inputs>
                  <Inputs>
                  <div>
                    <label htmlFor="status">Employee Status *</label>
                    <FormControl variant="standard" className="selectOtp">
                      <Select
                        value={userData.status}
                        onChange={handlerForm}
                        name="status"
                      >
                        <MenuItem value="Active">Active</MenuItem>
                        <MenuItem value="Inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </Inputs>
                  <Inputs>
                    <div>
                      <label htmlFor="salary">Salary</label>
                      <input
                        type="number"
                        id="salary"
                        name="salary"
                        value={userData.salary}
                        onChange={handlerForm}
                      />
                    </div>

                    {/*<div>
                      <label htmlFor="allowedLeaves">
                        Yearly Allowed Leaved
                      </label>
                      <input
                        type="number"
                        id="allowedLeaves"
                        name="allowedLeaves"
                        value={userData.allowedLeaves}
                        onChange={handlerForm}
                      />
                    </div>
                    <div>
                      <label htmlFor="weeklyWorkingDays">Working Days</label>
                      <input
                        type="number"
                        id="weeklyWorkingDays"
                        name="weeklyWorkingDays"
                        value={userData.weeklyWorkingDays}
                        onChange={handlerForm}
                      />
                    </div>*/}
                  </Inputs>
                  <Inputs>
                    <div>
                      <label htmlFor="designation">Designation</label>
                      <input
                        type="text"
                        id="designation"
                        name="designation"
                        value={userData.designation}
                        onChange={handlerForm}
                      />
                    </div>
                      {/*
                    <div>
                      <label htmlFor="department">
                        Department
                      </label>
                      <input
                        type="text"
                        id="department"
                        name="department"
                        value={userData.department}
                        onChange={handlerForm}
                      />
                    </div>*/}
                  </Inputs>  

                  {/* ✅ UPDATED UI FOR CHECKBOX */}
                  <CheckboxContainer>
                    <input
                      type="checkbox"
                      id="disableCheckInOut"
                      checked={userData.disableCheckInOut}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setUserData((prev) => ({
                          ...prev,
                          disableCheckInOut: checked,
                          checkIn: checked ? "" : prev.checkIn,
                          checkOut: checked ? "" : prev.checkOut,
                        }));
                      }}
                    />
                    <label htmlFor="disableCheckInOut">
                      Disable Check In / Check Out
                    </label>
                  </CheckboxContainer>

                  <Inputs>
                    <div>
                      <label htmlFor="checkIn">Check In</label>
                      <input
                        type="time"
                        id="checkIn"
                        name="checkIn"
                        value={userData.checkIn}
                        onChange={handlerForm}
                       disabled={userData.disableCheckInOut}
                      />
                    </div>
                    <div>
                      <label htmlFor="checkOut">Check Out</label>
                      <input
                        type="time"
                        id="checkOut"
                        name="checkOut"
                        value={userData.checkOut}
                        onChange={handlerForm}
                        disabled={userData.disableCheckInOut}
                      />
                    </div>
                  </Inputs>
                  <Btn onClick={handlerAddFields} showField={showField}>
                    {showField ? (
                      <>
                        <RemoveIcon />
                        HIDE ADDITIONAL DETAILS
                      </>
                    ) : (
                      <>
                        <AddIcon />
                        ADD ADDITIONAL DETAILS
                      </>
                    )}
                  </Btn>
                  {showField ? (
                    <>
                      <Inputs>
                        <div>
                          <label htmlFor="email">Email</label>
                          <input
                            type="text"
                            id="email"
                            name="email"
                            placeholder="Enter email"
                            value={userData.email}
                            onChange={handlerForm}
                          />
                        </div>
                      </Inputs>

                      <Inputs>
                        <div>
                          <label htmlFor="address">Address</label>
                          <input
                            type="text"
                            id="address"
                            name="address"
                            placeholder=""
                            value={userData.address}
                            onChange={handlerForm}
                          />
                        </div>
                      </Inputs>

                      <Inputs>
                        <div>
                          <label htmlFor="bankName">Bank Name</label>
                          <input
                            type="text"
                            id="bankName"
                            name="bankName"
                            placeholder="Enter bank name"
                            value={userData.bankName}
                            onChange={handlerForm}
                          />
                        </div>
                        <div>
                          <label htmlFor="bankAccountNumber">Bank Account Number</label>
                          <input
                            type="text"
                            id="bankAccountNumber"
                            name="bankAccountNumber"
                            placeholder="Enter bank account number"
                            value={userData.bankAccountNumber}
                            onChange={handlerForm}
                          />
                        </div>
                      </Inputs>

                      <Inputs>
                        <div>
                          <label htmlFor="doj">Date Of Join</label>
                          <input
                            type="date"
                            id="doj"
                            name="doj"
                            placeholder="01/01/2025"
                            value={userData.doj}
                            onChange={handlerForm}
                          />
                        </div>
                      </Inputs>

                      <Inputs>
                        <div>
                          <label htmlFor="panNumber">Pan Number</label>
                          <input
                            type="text"
                            id="panNumber"
                            name="panNumber"
                            placeholder="000"
                            value={userData.panNumber}
                            onChange={handlerForm}
                          />
                        </div>
                        <div>
                          <label htmlFor="pfNumber">PF Number</label>
                          <input
                            type="text"
                            id="pfnumber"        
                            name="pfnumber"      
                            placeholder="000"
                            value={userData.pfnumber}
                            onChange={handlerForm}
                          />
                        </div>
                      </Inputs>
             <Inputs>
  <div>
    <label htmlFor="aadharNumber">Aadhaar Number *</label>
    <input
  type="tel"
  id="aadharNumber"
  name="aadharNumber"
  maxLength={12}
  value={userData.aadharNumber}
  onChange={handlerForm}
  required    // ADD THIS LINE
/>
  </div>
</Inputs>

<Section>
  <Label>Driving Licence</Label>

  <ToggleGroup>
    <ToggleBtn
      active={userData.hasDrivingLicence === "yes"}
      type="button"
      onClick={() =>
        setUserData(prev => ({...prev, hasDrivingLicence: "yes"}))
      }
    >
      I have licence
    </ToggleBtn>

    <ToggleBtn
      active={userData.hasDrivingLicence === "no"}
      type="button"
      onClick={() =>
        setUserData(prev => ({...prev, hasDrivingLicence: "no", drivingLicence: ""}))
      }
    >
      No licence
    </ToggleBtn>
  </ToggleGroup>

  <Inputs style={{opacity: userData.hasDrivingLicence === "yes" ? 1 : 0.4}}>
    <div>
      <label htmlFor="drivingLicence">Licence Number</label>
      <input
        type="text"
        id="drivingLicence"
        name="drivingLicence"
        value={userData.drivingLicence || ""}  // Added fallback
        onChange={handlerForm}
        disabled={userData.hasDrivingLicence !== "yes"}
        required={userData.hasDrivingLicence === "yes"}
      />
    </div>
  </Inputs>
</Section>

                      {/*<Inputs>
                        <div>
                          <label htmlFor="uanNumber">UAN number</label>
                          <input
                            type="text"
                            id="uanNumber"
                            name="uanNumber"
                            placeholder="000"
                            value={userData.uanNumber}
                            onChange={handlerForm}
                          />
                        </div>
                        <div>
                          <label htmlFor="esicNumber">ESIC Number</label>
                          <input
                            type="text"
                            id="esicNumber"
                            name="esicNumber"
                            placeholder="000"
                            value={userData.esicNumber}
                            onChange={handlerForm}
                          />
                        </div>
                      </Inputs>*/}

                      <Checks>
                        <div>
                          <label htmlFor="dob">Date Of Birth</label>
                          <input
                            type="date"
                            id="dob"
                            name="dob"
                            placeholder="01/01/2025"
                            value={userData.dob}
                            onChange={handlerForm}
                          />
                        </div>
                        <div>
                          <p>Gender</p>
                          <CheckList>
                            <input
                              type="radio"
                              id="Male"
                              name="gender"
                              placeholder="Male"
                              value="Male"
                              onChange={handlerForm}
                              checked={userData.gender === "Male"}
                            />
                            <label htmlFor="Male">Male</label>

                            <input
                              type="radio"
                              id="Female"
                              name="gender"
                              placeholder="Male"
                              value="Female"
                              onChange={handlerForm}
                              checked={userData.gender === "Female"}
                            />
                            <label htmlFor="Female">Female</label>

                            <input
                              type="radio"
                              id="Others"
                              name="gender"
                              placeholder="Others"
                              value="Others"
                              onChange={handlerForm}
                              checked={userData.gender === "Others"}
                            />
                            <label htmlFor="Others">Others</label>
                          </CheckList>
                        </div>
                      </Checks>
                      <Inputs>
                        <div>
                          <label htmlFor="education">
                            Educational Qualifications
                          </label>
                          <FormControl variant="standard" className="selectOtp">
                            <input
                              type="text"
                              id="education"
                              name="education"
                              value={userData.education}
                              onChange={handlerForm}
                            />
                          </FormControl>
                        </div>
                        <div>
                          <label htmlFor="blood">Blood Group(Optional)</label>
                          <FormControl variant="standard" className="selectOtp">
                            <Select
                              labelId="demo-simple-select-standard-label"
                              id="demo-simple-select-standard"
                              value={userData.blood ? userData.blood : ""}
                              onChange={handlerForm}
                              label="blood"
                              name="blood"
                            >
                              <MenuItem value="" disabled={true}>
                                <em>Select Blood Group</em>
                              </MenuItem>
                              {bloodgrps.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item}>
                                    {item}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </div>
                      </Inputs>
                      <AddDocuments
                        documents={documents}
                        setDocuments={setDocuments}
                      />
                      <Inputs>
                        <div>
                          <label htmlFor="emergencyContact">
                            Emergency Contact
                          </label>
                          <input
                            type="tel"
                            id="emergencyContact"
                            name="emergencyContact"
                            placeholder="10 digit number"
                            value={userData.emergencyContact}
                            onChange={handlerForm}
                            maxLength={10}
                            inputMode="numeric"  
                            pattern="[0-9]*"    
                          />

                        </div>
                      </Inputs>
                    </>
                  ) : null}

                  <Btns>
                    <button type="submit">
                      {formId ? "UPDATE" : " CREATE"}
                    </button>
                    <button type="button" onClick={handleClose}>CANCEL</button>
                  </Btns>
                </form>
              </Form>
            </Box>
          </Container>
        </>
      ) : null}
    </>
  );
};
// #2F80ED

const Btn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  padding: 10px 70px;
  border: 2px solid;
  border-color: ${(props) => (props.showField ? "#999" : "#d32f2f")};
  background-color: #fff;
  color: ${(props) => (props.showField ? "#999" : "#d32f2f")};
  border-radius: 3px;
  cursor: pointer;
  font-weight: 530;
  letter-spacing: 1.5px;
  font-weight: 600;
`;

const Container = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.2);
  width: 100%;
`;

const Box = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  max-width: 600px;
  margin-top: 20px;
  height: 95vh;
  overflow-y: auto;
  margin-left: auto;

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-clip: content-box;
    height: 50vh;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
  position: sticky;
  top: 0;
  background-color: #fff;
  padding: 20px;
`;

const Icon = styled.div`
  cursor: pointer;
  padding: 5px;
  /* background-color: red; */
`;

const Form = styled.div`
  padding: 20px;
  padding-top: 0;
  form {
    display: flex;
    flex-direction: column;
    gap: 30px;
    label {
      color: rgba(0, 0, 0, 0.6);
      font-size: 15px;
      font-weight: 500;
    }
    input {
      &::placeholder {
        color: #000;
        font-size: 15px;
        font-weight: 500;
      }
    }
  }
`;

const SelctPhoto = styled.div`
  input {
    display: none;
    text-align: center;
  }
  label {
    display: block;
    text-align: center;
    color: #1976d2 !important;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const BgImg = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dedede;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    display: inline-block;
    object-fit: cover;
  }
`;

const Inputs = styled.div`
  .document-images {
    width: 48%;
  }
  display: flex;
  align-items: center;
  width: 100%;
  gap: 20px;
  div {
    flex-basis: 100%;
  }
  input {
    width: 100%;
    padding: 10px;
    border: none;
    outline: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    margin-bottom: 10px;
  }
  select {
    border: none;
    outline: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    padding: 10px;
    width: 100%;
    margin-bottom: 10px;
  }
`;

const Btns = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
  position: sticky;
  bottom: 0;
  background-color: #fff;
  padding: 10px 0;
  button {
    background: #d32f2f;
    padding: 10px 70px;
    border: none;
    outline: none;
    color: #fff;
    border-radius: 3px;
    cursor: pointer;
    font-weight: 530;
    letter-spacing: 1.5px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    &:last-child {
      background: #fff;
      color: #000;
      box-shadow: none;
      border: 1px solid #000;
    }
  }
`;

const Checks = styled.div`
  display: flex;
  gap: 30px;
  align-items: flex-start;

  div {
    flex: 1;
  }

  p {
    margin-bottom: 8px;
    font-weight: 500;
  }

  /* ONLY date input full width */
  input[type="date"] {
    width: 100%;
    padding: 10px;
    border: none;
    outline: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  }
`;

const CheckList = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// ✅ NEW STYLED COMPONENT FOR THE CHECKBOX
const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background-color: #f5f5f5; /* Light grey background to make it stand out */
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #eef2f6;
    border-color: #2F80ED;
  }

  input[type="checkbox"] {
    width: 20px; /* Reset width so it's not 100% */
    height: 20px;
    margin-right: 12px;
    cursor: pointer;
    accent-color: #2F80ED; /* Matches your button color */
    border-bottom: none; /* Removes the line under the checkbox */
  }

  label {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
    user-select: none;
  }
    
`;
const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Label = styled.label`
  font-weight: 600;
  font-size: 15px;
  color: #333;
`;

const ToggleGroup = styled.div`
  display: flex;
  gap: 12px;
`;

const ToggleBtn = styled.button`
  padding: 8px 18px;
  border-radius: 6px;
  border: 1.5px solid ${props => (props.active ? "#d32f2f" : "#ccc")};
  background: ${props => (props.active ? "#fdecea" : "#fff")};
  color: ${props => (props.active ? "#d32f2f" : "#555")};
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    border-color: #d32f2f;
    color: #d32f2f;
  }
`;

export default AddUser;